import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { reopenBroadcast } from 'api/broadcasts.service';
import { setDraftBroadcast } from 'store/broadcast';
import { useApplicationStore } from 'store/application';
import { broadcastKeys } from './queryKeys';

export const useBroadcastReopenQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return reopenBroadcast(id);
    },
    onSuccess: (broadcast) => {
      toast.success('Broadcast has been reopened successfully');
      setDraftBroadcast(broadcast);
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: broadcastKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
